<template lang="html">
  <div style="padding-bottom:10rem;">
    <div class="text-center animate__animated animate__zoomIn blue--text heading">
      <p>{{"Dongo-Kundu Bypass: "}}</p>
    </div>
    <v-row class="no-gutters">
      <v-col class="col-12 px-2">
        The world has developed in the last 3 centuries more than it did in all recorded history before the 18th century. Most of these developments may be credited primarily to the 
        opening up of transportation channels. For instance, the USA was arguably built on the railway; the widespread adaptation of railways of the 1800s in the USA brought with it 
        massive economic benefits to individuals and the society at large. Another example, China put road infrastructure development at the core of its strategy when it set out to 
        foster economic prosperity; it has since developed more than a million kilometers since. There seems to be an alternating but direct cause-effect relationship between roads and
        economic development, where good road infrastructure causes economic prosperity and vice versa. Kenya is not blind to this fact, with road infrastructure development being
        integral to Vision 2030’s economic pillar. One such project aimed toward this goal is the Dongo Kundu Bypass Highway.
      </v-col>
      <v-col class="col-12 px-2">
        <p class="blue--text sub-heading mt-2">{{"The Gate to the South Coast"}}</p>
      </v-col>
      <v-col class="col-12 px-2">
        Also known as the Mombasa Southern Bypass Highway, the 17.5KM, four-lane stretch of road is a brainchild of the past government which planned it in 2004. The plans to initiate 
        the construction began in 2014 with a $110 B loan from Japan International Cooperation Agency (JICA). Its actual construction began in 2018 by the China Civil Engineering 
        Construction Corporation and is set to be complete in 2024. It is currently 85% complete. (at the time of writing this blog) 
      </v-col>
      <v-col class="col-12 px-2 d-flex justify-center">
        <v-img class="rounded lighten-4"
        :src="require(`../assets/bypass_1.jpg`)"
        />
      </v-col>
      <v-col class="col-12 px-2">
        It begins on its Northside in Miritini and on the 
        Southside, Ng’ombeni; its path negates the need to go through the Mombasa Island to get from the North mainland to the South Mainland. It has four bridges that navigate users 
        through ocean-water swamps. This makes the road a holy grail that could not come at a better time. It will accord South Coast dwellers ample benefits by opening up the area to 
        trade, investments, and tourism. The next section elaborates on some of the ways that the Bypass will open up the south coast.     
      </v-col>
      <v-col class="col-12 px-2">
        <p class="blue--text sub-heading mt-2">{{"Benefits of Dongo Kundu to South Coast"}}</p>
      </v-col>
      <v-col class="col-12 px-2">
        <h4 class="ml-3 mt-1 blue--text">{{"Provide Easy Access to the Proposed Dongo-Kundu Special Economic Zone Area"}}</h4>
      </v-col>
      <v-col class="col-12 px-2">
      The Special Economic Zone Authority (SEZA) proposed an SEZ in Dongo Kundu as part of its master plan to supplement the Vision 2030. The proposal was approved, and the initial 
      funding of the ultimate budget of approximately $1.5B was already sourced from Japan. A public-private partnership model funds the project. On completion, it will have more than
      <b>6,000 sites</b> to house about <b>10,000 Business Units</b>. Besides that, it will also house a logistics hub, freeport and an industrial zone.
      There are several access roads to the zone; however, the Dongo Kundu Bypass is the biggest, having four lanes. It also opens up the south coast area from the North, where most 
      economic activities occur.
      </v-col>
      <v-col class="col-12 px-2">
        <h4 class="ml-3 mt-1 blue--text">{{"Make Transit of Goods from Inland Kenya to Tanzania through Mombasa more efficient"}}</h4>
      </v-col>
      <v-col class="col-12 px-2">
        	Currently, most transit vehicles destined for Tanzania avoid passing through Mombasa due to the congestion passing through the island. The bypass will remove the need to go 
          through the island, and it is only natural that more transit vehicles will start to use the route. Transit business is a mobile economy, they, in a literal sense, carry 
          resources/ prosperity, and some sift through to settle in the towns they pass through. This is currently sustaining Namanga’s economy. The passing of these transit vehicles 
          through the South Coast is bound to introduce new investment opportunities such as: <br>
          <ul class="ml-4">
            <li class="ml-4">Lodgings and Guest houses</li>
            <li class="ml-4">Ware houses</li>
            <li class="ml-4">Security Firms</li>
            <li class="ml-4">Fueling Station </li>
            <li class="ml-4">Merry-making establishments, among others.</li>
          </ul>
          More importantly, it will increase the population of the area and all the good things that that comes with.
      </v-col>
      <v-col class="col-12 px-2">
        <h4 class="ml-3 mt-1 blue--text">{{"Foster Tourism"}}</h4>
      </v-col>
      <v-col class="col-12 px-2">
        The south coast has some of the best beaches in the Country. The Diani White Sand Beach has international acclaim. However, it is not easily accessible from the North.
        One has to go through the rigmarole of boarding a ferry and navigating through the congested island, which ultimately makes for a bad experience for an individual whose 
        current concern is ‘enjoyment.’ The bypass will make the journey smoother by reducing traffic and the net distance traveled. Yes, the bypass is a shortcut.
        Also, the presence of the SEZ will widen the scope of the types of tourism in the area by introducing ‘economic tourism.’ This is where tourists visit an area to learn about 
        business policies, operations and the sorts; it is commonly known as benchmarking.
        We could go for eons just debating how the Bypass would open up the South Coast; however, the most important debate should be, how are you setting yourself up to reap some of 
        these benefits? The Bypass is less than two years away from completion; therefore, if one intends to move to the South Coast, never has there ever been a better time than this.
        The most secure way to position yourself in the path of the imminent windfall is by owning a piece of land in the area. Land does not depreciate. At Adili Real Estate, we have
        gone through the trouble of identifying some of the lands on the South Coast that promise such returns. This gives you the responsibility of being interested in investing in 
        the future of Kenya for yourself. You may view some of the properties 
         <span class="pointer blue--text" @click="goToSection('properties')">Here</span>
         , Book the land 
         <span class="pointer blue--text" @click="goToSection('book')">Here</span>
         , or contact us.
         <span class="pointer blue--text" @click="goToSection('contact')">Here</span>
      </v-col>
      <v-col class="col-6 offset-3 px-2 d-flex justify-center">
        <v-img class="rounded lighten-4"
        :src="require(`../assets/slice.png`)"
        />
      </v-col>
      <v-col class="col-12 px-2 d-flex justify-center">
        Own a slice of the Future. <br>
      </v-col>
      <v-col class="col-12 px-2 d-flex justify-center">
        <v-btn large class="red white--text ml-1" @click="buyNow">
          BUY NOW!
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'dongoKunduBlog',
  data(){
    return{
      contact_data: {}
    }
  },
  methods: {
    go(code){
      window.location = code
    },
    goToSection(element_id){
      this.go('/' + element_id)
    },
    buyNow(){
      let url = "https://wa.me/+254720244744?text=I%20want%20to%20buy%20this%20land%20now!"
      window.open(url,'_blank')
    }
  }
}
</script>
